import { useMe } from "@/data/user.ts";
import { Navigate } from "react-router-dom";
import ROUTES from "@/config/routes.ts";
import LinearProgress from "@/components/ui/LinearProgress.tsx";

export default function Dashboard() {
  const { me, isAuthorized } = useMe();
  const isUser = !!(me && me.status === 200);
  if (!isUser && !isAuthorized) {
    return <Navigate to={ROUTES.login} />;
  }
  if (isUser && isAuthorized) {
    return <Navigate to={ROUTES.home} />;
  }
  return <LinearProgress />;
}
